import { Pipe, PipeTransform } from '@angular/core';
import { CourierProfileService } from '../services/courier-profile.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'packagingType',
    standalone: true
})
export class PackagingTypePipe implements PipeTransform {

    constructor(private courierProfileService: CourierProfileService) {}

    transform(value: string, ...args: unknown[]): Observable<string> {
        return this.courierProfileService.packagingTypes$.pipe(
            map(definitions => definitions.find(d => d.code === value)),
            map(definition => definition.caption)
        );
    }

}
